/* eslint-disable */
import createFromPromise from './Promise.from';

/**
 * Creates an injectable function that will be able to handle the life cycle of a callback
 * @param {Store} store The state management `store`
 * @returns {FromCallback} The `dispatch` aware injectable
 */
const createFromCallback = (store) => (callback, meta, [FROM_CALLBACK, FROM_CALLBACK_COMPLETE, FROM_CALLBACK_ERROR, FROM_CALLBACK_SUCCESS]) => {
  const fromPromise = createFromPromise(store);
  const promise = new Promise((resolve, reject) => {
    callback((error, payload) => {
      if (error) {
        reject(error);
      } else {
        resolve(payload);
      }
    });
  });
  return fromPromise(promise, meta, [FROM_CALLBACK, FROM_CALLBACK_COMPLETE, FROM_CALLBACK_ERROR, FROM_CALLBACK_SUCCESS]);
};

export default createFromCallback;
